// extracted by mini-css-extract-plugin
module.exports =  {"menuContainer":"VirtualListWithKeyboard-module_menuContainer__aP5cMpF_x766foTbxG8A","empty":"VirtualListWithKeyboard-module_empty__NkzmKh2uckRE90_ON3cD"};